module.exports = __webpack_public_path__ + "media/winter.a6e71d12.mp3";